import { useTenantStore } from '@features/tenant/store/tenant';

export type CentralSsoProvider = 'google' | 'apple';

export const buildCentralSsoUrl = (
  provider: CentralSsoProvider,
  operationId: string,
  currentPath: string,
  authUrl: string = import.meta.env.VITE_AUTH_URL,
  origin: string = window.location.origin,
): string => {
  const returnTo = `${origin}/auth/callback?provider=${provider}&next=${encodeURIComponent(currentPath)}`;
  const url = new URL(`${authUrl}/public/sso/${provider}/start`, origin);
  url.searchParams.set('operation_id', operationId);
  url.searchParams.set('return_to', returnTo);
  return url.toString();
};

export const startCentralSso = (
  provider: CentralSsoProvider,
  path?: string,
): void => {
  const tenantStore = useTenantStore();
  const currentPath =
    path ?? `${window.location.pathname}${window.location.search}`;
  window.location.assign(
    buildCentralSsoUrl(provider, tenantStore.operationId, currentPath),
  );
};
